import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ENVIRONMENT } from '../tokens';
import { RtcErrorHandler } from './error-handler';

const DUPLICATE_THRESHOLD_MS = 500;

@Injectable({ providedIn: 'root' })
export class RateLimiterInterceptorService implements HttpInterceptor {
  private lastRequestMap = new Map<string, { time: number }>();

  constructor(
    @Inject(ENVIRONMENT) private environment: { ENV: 'production' | 'staging' | 'development' },
    private errorHandler: RtcErrorHandler,
  ) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if ('staging' === this.environment.ENV) {
      this.trackDuplicates(req);
    }
    return next.handle(req);
  }

  private trackDuplicates(req: HttpRequest<any>): void {
    const previousRequest = this.lastRequestMap.get(req.urlWithParams);
    const currentTime = Date.now();
    this.lastRequestMap.set(req.urlWithParams, { time: currentTime });
    if (!previousRequest) return;

    const diff = currentTime - previousRequest.time;
    if (diff > DUPLICATE_THRESHOLD_MS) return;

    const name = `Duplicate call "${req.urlWithParams}"`;
    this.errorHandler.trace(name, false);
    console.warn(`${name}. Diff: ${diff}ms`);
  }
}
